<script>
export default {
  props: {
    content: null,
    isHtml: Boolean,
  },
  render(h) {
    if (this.isHtml) {
      return h("div", {
        class: {
          "mm-dialog-message": true,
        },
        domProps: {
          innerHTML: this.content,
        },
      })
    } else {
      return h("div", {
        class: {
          "mm-dialog-message": true,
        },
      }, Array.isArray(this.content) ? this.content : [this.content])
    }
  },
}
</script>
